import { render, staticRenderFns } from "./CommboxConversationDetailsPage.vue?vue&type=template&id=683c988a&scoped=true&"
import script from "./CommboxConversationDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CommboxConversationDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./CommboxConversationDetailsPage.vue?vue&type=style&index=0&id=683c988a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c988a",
  null
  
)

export default component.exports